import { StoreNotification } from "@/store/constants";
import { appData, C, D } from "@/helpers/global";

export default {
    namespaced: true,
    state: () => ({
        list: appData.fn.getSession(StoreNotification.state.list, []),
    }),
    mutations: {
        setListItem(state, data) {
            let isIn = false;
            state.list.forEach((r) => {
                if (r.id == data.id) {
                    r = data;
                    isIn = true;
                }
            });
            if (isIn) {
                appData.fn.setSession(StoreNotification.state.list, state.list);
            }
        },
        setList(state, data) {
            for (let i = 0; i < data.length; i++) {
                let isIn = false;
                state.list.forEach((r) => {
                    if (r.id == data[i].id) {
                        r == data[i];
                        isIn = true;
                    }
                });
                if (!isIn) {
                    state.list.push(data[i]);
                }
            }
            appData.fn.setSession(StoreNotification.state.list, state.list);
        },
    },
    actions: {
        setListItem(ctx, data) {
            ctx.commit("setListItem", data);
        },
        setList(ctx, data) {
            ctx.commit("setList", data);
        },
    },
    getters: {
        getEndSendDateUnReaded(state) {
            const l = state.list.filter((r) => C.Bool(r.isReaded) == false);
            if (l.length === 0) {
                return null;
            }
            const maxDate = l.reduce((max, r) => {
                return r.sendDate > max ? r.sendDate : max;
            }, l[0].sendDate);
            return maxDate;
        },
        getEndSendDate(state) {
            const l = state.list;
            if (l.length === 0) {
                return null;
            }
            const maxDate = l.reduce((max, r) => {
                return r.sendDate > max ? r.sendDate : max;
            }, l[0].sendDate);
            return maxDate;
        },
        getCountUnReaded(state) {
            return state.list.filter((r) => C.Bool(r.isReaded) == false).length;
        },
        getCountReaded(state) {
            return state.list.filter((r) => C.Bool(r.isReaded) == true).length;
        },
        getListUnReaded(state) {
            const l = state.list;
            return l.filter((r) => C.Bool(r.isReaded) == false).sort((a, b) => new Date(b.sendDate).getTime() - new Date(a.sendDate).getTime());
        },
        getListAll(state) {
            const l = state.list;
            return l.sort((a, b) => new Date(b.sendDate).getTime() - new Date(a.sendDate).getTime());
        },
    }
};